export default [
  {
    id: 1000,
    key: 'bj',
    value: '北京'
  },
  {
    id: 3000,
    key: 'tj',
    value: '天津'
  },
  {
    id: 13000,
    key: 'hb',
    value: '河北',
    children: [
      {
        id: 13327,
        key: 'sjz',
        value: '石家庄'
      },
      {
        id: 13329,
        key: 'ts',
        value: '唐山'
      },
      {
        id: 13325,
        key: 'qhd',
        value: '秦皇岛'
      },
      {
        id: 13330,
        key: 'hd',
        value: '邯郸'
      },
      {
        id: 13326,
        key: 'xt',
        value: '邢台'
      },
      {
        id: 13331,
        key: 'zjk',
        value: '张家口'
      },
      {
        id: 13306,
        key: 'cd',
        value: '承德'
      },
      {
        id: 13307,
        key: 'lf',
        value: '廊坊'
      },
      {
        id: 13332,
        key: 'hs',
        value: '衡水'
      },
      {
        id: 13305,
        key: 'cz',
        value: '沧州'
      },
      {
        id: 13304,
        key: 'bd',
        value: '保定'
      }
    ]
  },
  {
    id: 26000,
    key: 'sx',
    value: '山西',
    children: [
      {
        id: 26214,
        key: 'ty',
        value: '太原'
      },
      {
        id: 26217,
        key: 'dt',
        value: '大同'
      },
      {
        id: 26215,
        key: 'yq',
        value: '阳泉'
      },
      {
        id: 26209,
        key: 'cz',
        value: '长治'
      },
      {
        id: 26205,
        key: 'jz',
        value: '晋城'
      },
      {
        id: 26213,
        key: 'sz',
        value: '朔州'
      },
      {
        id: 26206,
        key: 'jz',
        value: '晋中'
      },
      {
        id: 26216,
        key: 'yc',
        value: '运城'
      },
      {
        id: 26212,
        key: 'xz',
        value: '忻州'
      },
      {
        id: 26211,
        key: 'lf',
        value: '临汾'
      },
      {
        id: 26210,
        key: 'll',
        value: '吕梁'
      }
    ]
  },
  {
    id: 22000,
    key: 'nmg',
    value: '内蒙古',
    children: [
      {
        id: 22167,
        key: 'hhkt',
        value: '呼和浩特'
      },
      {
        id: 22169,
        key: 'bt',
        value: '包头'
      },
      {
        id: 22164,
        key: 'wk',
        value: '乌海'
      },
      {
        id: 22158,
        key: 'cf',
        value: '赤峰'
      },
      {
        id: 22161,
        key: 'tl',
        value: '通辽'
      },
      {
        id: 22168,
        key: 'eeds',
        value: '鄂尔多斯'
      },
      {
        id: 22166,
        key: 'hlbe',
        value: '呼伦贝尔'
      },
      {
        id: 22163,
        key: 'wlcb',
        value: '乌兰察布'
      },
      {
        id: 22165,
        key: 'xlgl',
        value: '锡林郭勒盟'
      },
      {
        id: 22162,
        key: 'byze',
        value: '巴彦淖尔'
      },
      {
        id: 22159,
        key: 'als',
        value: '阿拉善盟'
      },
      {
        id: 22160,
        key: 'xam',
        value: '兴安盟'
      }
    ]
  },
  {
    id: 18000,
    key: 'jl',
    value: '吉林',
    children: [
      {
        id: 18040,
        key: 'cc',
        value: '长春'
      },
      {
        id: 18038,
        key: 'jl',
        value: '吉林'
      },
      {
        id: 18043,
        key: 'sp',
        value: '四平'
      },
      {
        id: 18041,
        key: 'ly',
        value: '辽源'
      },
      {
        id: 18045,
        key: 'th',
        value: '通化'
      },
      {
        id: 18042,
        key: 'bs',
        value: '白山'
      },
      {
        id: 18047,
        key: 'yb',
        value: '延边'
      },
      {
        id: 18039,
        key: 'bc',
        value: '白城'
      },
      {
        id: 18044,
        key: 'sy',
        value: '松原'
      }
    ]
  },
  {
    id: 21000,
    key: 'll',
    value: '辽宁',
    children: [
      {
        id: 21153,
        key: 'sy',
        value: '沈阳'
      },
      {
        id: 21155,
        key: 'dl',
        value: '大连'
      },
      {
        id: 21151,
        key: 'as',
        value: '鞍山'
      },
      {
        id: 21152,
        key: 'fs',
        value: '抚顺'
      },
      {
        id: 21145,
        key: 'bx',
        value: '本溪'
      },
      {
        id: 21144,
        key: 'dd',
        value: '丹东'
      },
      {
        id: 21146,
        key: 'jz',
        value: '锦州'
      },
      {
        id: 21157,
        key: 'hld',
        value: '葫芦岛'
      },
      {
        id: 21156,
        key: 'yk',
        value: '营口'
      },
      {
        id: 21149,
        key: 'pj',
        value: '盘锦'
      },
      {
        id: 21150,
        key: 'fx',
        value: '阜新'
      },
      {
        id: 21148,
        key: 'ly',
        value: '辽阳'
      },
      {
        id: 21154,
        key: 'tl',
        value: '铁岭'
      },
      {
        id: 21147,
        key: 'zy',
        value: '朝阳'
      }
    ]
  },
  {
    id: 15000,
    key: 'hlj',
    value: '黑龙江',
    children: [
      {
        id: 15335,
        key: 'heb',
        value: '哈尔滨'
      },
      {
        id: 15337,
        key: 'qqhe',
        value: '齐齐哈尔'
      },
      {
        id: 15344,
        key: 'hg',
        value: '鹤岗'
      },
      {
        id: 15340,
        key: 'sys',
        value: '双鸭山'
      },
      {
        id: 15333,
        key: 'jx',
        value: '鸡西'
      },
      {
        id: 15342,
        key: 'dq',
        value: '大庆'
      },
      {
        id: 15341,
        key: 'yc',
        value: '伊春'
      },
      {
        id: 15336,
        key: 'mdj',
        value: '牡丹江'
      },
      {
        id: 15334,
        key: 'jms',
        value: '佳木斯'
      },
      {
        id: 15338,
        key: 'qth',
        value: '七台河'
      },
      {
        id: 15345,
        key: 'hh',
        value: '黑河'
      },
      {
        id: 15339,
        key: 'nh',
        value: '绥化'
      },
      {
        id: 15343,
        key: 'dxal',
        value: '大兴安岭'
      }
    ]
  },
  {
    id: 2000,
    key: 'sh',
    value: '上海'
  },
  {
    id: 5000,
    key: 'fj',
    value: '福建',
    children: [
      {
        id: 5081,
        key: 'fz',
        value: '福州'
      },
      {
        id: 5070,
        key: 'xm',
        value: '厦门'
      },
      {
        id: 5066,
        key: 'sm',
        value: '三明'
      },
      {
        id: 5048,
        key: 'pt',
        value: '莆田'
      },
      {
        id: 5052,
        key: 'qz',
        value: '泉州'
      },
      {
        id: 5080,
        key: 'zz',
        value: '漳州'
      },
      {
        id: 5049,
        key: 'np',
        value: '南平'
      },
      {
        id: 5050,
        key: 'ly',
        value: '龙岩'
      },
      {
        id: 5051,
        key: 'nd',
        value: '宁德'
      }
    ]
  },
  {
    id: 9000,
    key: 'ah',
    value: '安徽',
    children: [
      {
        id: 9142,
        key: 'hf',
        value: '合肥'
      },
      {
        id: 9139,
        key: 'wh',
        value: '芜湖'
      },
      {
        id: 9141,
        key: 'bb',
        value: '蚌埠'
      },
      {
        id: 9133,
        key: 'hn',
        value: '淮南'
      },
      {
        id: 9134,
        key: 'mas',
        value: '马鞍山'
      },
      {
        id: 9127,
        key: 'hb',
        value: '淮北'
      },
      {
        id: 9138,
        key: 'tl',
        value: '铜陵'
      },
      {
        id: 9128,
        key: 'aq',
        value: '安庆'
      },
      {
        id: 9132,
        key: 'hs',
        value: '黄山'
      },
      {
        id: 9131,
        key: 'cz',
        value: '滁州'
      },
      {
        id: 9140,
        key: 'fy',
        value: '阜阳'
      },
      {
        id: 9137,
        key: 'sz',
        value: '宿州'
      },
      {
        id: 9135,
        key: 'la',
        value: '六安'
      },
      {
        id: 9143,
        key: 'hz',
        value: '亳州'
      },
      {
        id: 9130,
        key: 'cz',
        value: '池州'
      },
      {
        id: 9136,
        key: 'xc',
        value: '宣城'
      }
    ]
  },
  {
    id: 19000,
    key: 'js',
    value: '江苏',
    children: [
      {
        id: 19055,
        key: 'nj',
        value: '南京'
      },
      {
        id: 19058,
        key: 'xz',
        value: '徐州'
      },
      {
        id: 19057,
        key: 'lyg',
        value: '连云港'
      },
      {
        id: 19053,
        key: 'ha',
        value: '淮安'
      },
      {
        id: 19060,
        key: 'sq',
        value: '宿迁'
      },
      {
        id: 19063,
        key: 'yc',
        value: '盐城'
      },
      {
        id: 19064,
        key: 'yz',
        value: '扬州'
      },
      {
        id: 19061,
        key: 'tz',
        value: '泰州'
      },
      {
        id: 19056,
        key: 'nt',
        value: '南通'
      },
      {
        id: 19065,
        key: 'zj',
        value: '镇江'
      },
      {
        id: 19054,
        key: 'cz',
        value: '常州'
      },
      {
        id: 19062,
        key: 'wx',
        value: '无锡'
      },
      {
        id: 19059,
        key: 'sz',
        value: '苏州'
      }
    ]
  },
  {
    id: 20000,
    key: 'jx',
    value: '江西',
    children: [
      {
        id: 20072,
        key: 'nc',
        value: '南昌'
      },
      {
        id: 20069,
        key: 'jd',
        value: '景德镇'
      },
      {
        id: 20071,
        key: 'px',
        value: '萍乡'
      },
      {
        id: 20067,
        key: 'jj',
        value: '九江'
      },
      {
        id: 20073,
        key: 'xy',
        value: '新余'
      },
      {
        id: 20076,
        key: 'yt',
        value: '鹰潭'
      },
      {
        id: 20077,
        key: 'gz',
        value: '赣州'
      },
      {
        id: 20068,
        key: 'ja',
        value: '吉安'
      },
      {
        id: 20075,
        key: 'yc',
        value: '宜春'
      },
      {
        id: 20078,
        key: 'fz',
        value: '抚州'
      },
      {
        id: 20074,
        key: 'sr',
        value: '上饶'
      }
    ]
  },
  {
    id: 25000,
    key: 'sd',
    value: '山东',
    children: [
      {
        id: 25196,
        key: 'jn',
        value: '济南'
      },
      {
        id: 25202,
        key: 'qd',
        value: '青岛'
      },
      {
        id: 25207,
        key: 'zb',
        value: '淄博'
      },
      {
        id: 25221,
        key: 'zz',
        value: '枣庄'
      },
      {
        id: 25220,
        key: 'dy',
        value: '东营'
      },
      {
        id: 25204,
        key: 'wf',
        value: '潍坊'
      },
      {
        id: 25219,
        key: 'yt',
        value: '烟台'
      },
      {
        id: 25218,
        key: 'wh',
        value: '威海'
      },
      {
        id: 25197,
        key: 'jn',
        value: '济宁'
      },
      {
        id: 25208,
        key: 'ta',
        value: '泰安'
      },
      {
        id: 25203,
        key: 'rz',
        value: '日照'
      },
      {
        id: 25198,
        key: 'lw',
        value: '莱芜'
      },
      {
        id: 25201,
        key: 'ly',
        value: '临沂'
      },
      {
        id: 25200,
        key: 'dz',
        value: '德州'
      },
      {
        id: 25199,
        key: 'lc',
        value: '聊城'
      },
      {
        id: 25223,
        key: 'bz',
        value: '滨州'
      },
      {
        id: 25222,
        key: 'hz',
        value: '菏泽'
      }
    ]
  },
  {
    id: 32000,
    key: 'zj',
    value: '浙江',
    children: [
      {
        id: 32280,
        key: 'hz',
        value: '杭州'
      },
      {
        id: 32276,
        key: 'nb',
        value: '宁波'
      },
      {
        id: 32278,
        key: 'wz',
        value: '温州'
      },
      {
        id: 32273,
        key: 'jx',
        value: '嘉兴'
      },
      {
        id: 32282,
        key: 'hz',
        value: '湖州'
      },
      {
        id: 32277,
        key: 'sx',
        value: '绍兴'
      },
      {
        id: 32272,
        key: 'jh',
        value: '金华'
      },
      {
        id: 32274,
        key: 'qz',
        value: '衢州'
      },
      {
        id: 32281,
        key: 'zs',
        value: '舟山'
      },
      {
        id: 32279,
        key: 'tz',
        value: '台州'
      },
      {
        id: 32275,
        key: 'ls',
        value: '丽水'
      }
    ]
  },
  {
    id: 14000,
    key: 'hn',
    value: '河南',
    children: [
      {
        id: 14322,
        key: 'zz',
        value: '郑州'
      },
      {
        id: 14310,
        key: 'kf',
        value: '开封'
      },
      {
        id: 14311,
        key: 'ly',
        value: '洛阳'
      },
      {
        id: 14313,
        key: 'pds',
        value: '平顶山'
      },
      {
        id: 14308,
        key: 'jz',
        value: '焦作'
      },
      {
        id: 14323,
        key: 'hb',
        value: '鹤壁'
      },
      {
        id: 14317,
        key: 'xx',
        value: '新乡'
      },
      {
        id: 14309,
        key: 'ay',
        value: '安阳'
      },
      {
        id: 14316,
        key: 'py',
        value: '濮阳'
      },
      {
        id: 14319,
        key: 'xc',
        value: '许昌'
      },
      {
        id: 14312,
        key: 'lh',
        value: '漯河'
      },
      {
        id: 14321,
        key: 'smx',
        value: '三门峡'
      },
      {
        id: 14315,
        key: 'ny',
        value: '南阳'
      },
      {
        id: 14320,
        key: 'sq',
        value: '商丘'
      },
      {
        id: 14318,
        key: 'xy',
        value: '信阳'
      },
      {
        id: 14324,
        key: 'zk',
        value: '周口'
      },
      {
        id: 14314,
        key: 'zmd',
        value: '驻马店'
      },
      {
        id: 14476,
        key: 'jy',
        value: '济源'
      }
    ]
  },
  {
    id: 16000,
    key: 'hb',
    value: '湖北',
    children: [
      {
        id: 16371,
        key: 'wh',
        value: '武汉'
      },
      {
        id: 16348,
        key: 'hs',
        value: '黄石'
      },
      {
        id: 16370,
        key: 'xy',
        value: '襄阳'
      },
      {
        id: 16369,
        key: 'sy',
        value: '十堰'
      },
      {
        id: 16347,
        key: 'jz',
        value: '荆州'
      },
      {
        id: 16376,
        key: 'yc',
        value: '宜昌'
      },
      {
        id: 16346,
        key: 'jm',
        value: '荆门'
      },
      {
        id: 16377,
        key: 'ez',
        value: '鄂州'
      },
      {
        id: 16365,
        key: 'xg',
        value: '孝感'
      },
      {
        id: 16349,
        key: 'hg',
        value: '黄冈'
      },
      {
        id: 16375,
        key: 'xn',
        value: '咸宁'
      },
      {
        id: 16367,
        key: 'sz',
        value: '随州'
      },
      {
        id: 16366,
        key: 'es',
        value: '恩施'
      },
      {
        id: 16372,
        key: 'xt',
        value: '仙桃'
      },
      {
        id: 16373,
        key: 'tm',
        value: '天门'
      },
      {
        id: 16364,
        key: 'qj',
        value: '潜江'
      },
      {
        id: 16368,
        key: 'slj',
        value: '神农架'
      }
    ]
  },
  {
    id: 17000,
    key: 'hn',
    value: '湖南',
    children: [
      {
        id: 17352,
        key: 'cs',
        value: '长沙'
      },
      {
        id: 17363,
        key: 'zz',
        value: '株洲'
      },
      {
        id: 17356,
        key: 'xt',
        value: '湘潭'
      },
      {
        id: 17360,
        key: 'hy',
        value: '衡阳'
      },
      {
        id: 17355,
        key: 'sy',
        value: '邵阳'
      },
      {
        id: 17361,
        key: 'yy',
        value: '岳阳'
      },
      {
        id: 17351,
        key: 'cd',
        value: '常德'
      },
      {
        id: 17358,
        key: 'zjj',
        value: '张家界'
      },
      {
        id: 17359,
        key: 'yy',
        value: '益阳'
      },
      {
        id: 17353,
        key: 'cz',
        value: '郴州'
      },
      {
        id: 17362,
        key: 'yz',
        value: '永州'
      },
      {
        id: 17350,
        key: 'hh',
        value: '怀化'
      },
      {
        id: 17354,
        key: 'ld',
        value: '娄底'
      },
      {
        id: 17357,
        key: 'xx',
        value: '湘西'
      }
    ]
  },
  {
    id: 4000,
    key: 'gd',
    value: '广东',
    children: [
      {
        id: 4084,
        key: 'gz',
        value: '广州'
      },
      {
        id: 4093,
        key: 'sz',
        value: '深圳'
      },
      {
        id: 4113,
        key: 'zh',
        value: '珠海'
      },
      {
        id: 4091,
        key: 'st',
        value: '汕头'
      },
      {
        id: 4094,
        key: 'sg',
        value: '韶关'
      },
      {
        id: 4115,
        key: 'hy',
        value: '河源'
      },
      {
        id: 4088,
        key: 'mz',
        value: '梅州'
      },
      {
        id: 4092,
        key: 'sw',
        value: '汕尾'
      },
      {
        id: 4116,
        key: 'dg',
        value: '东莞'
      },
      {
        id: 4112,
        key: 'zs',
        value: '中山'
      },
      {
        id: 4082,
        key: 'jm',
        value: '江门'
      },
      {
        id: 4090,
        key: 'fs',
        value: '佛山'
      },
      {
        id: 4109,
        key: 'yj',
        value: '阳江'
      },
      {
        id: 4110,
        key: 'zj',
        value: '湛江'
      },
      {
        id: 4086,
        key: 'mm',
        value: '茂名'
      },
      {
        id: 4114,
        key: 'zq',
        value: '肇庆'
      },
      {
        id: 4089,
        key: 'qy',
        value: '清远'
      },
      {
        id: 4085,
        key: 'cz',
        value: '潮州'
      },
      {
        id: 4083,
        key: 'jy',
        value: '揭阳'
      },
      {
        id: 4111,
        key: 'yf',
        value: '云浮'
      },
      {
        id: 4117,
        key: 'hz',
        value: '惠州'
      }
    ]
  },
  {
    id: 8000,
    key: 'hn',
    value: '海南',
    children: [
      {
        id: 8302,
        key: 'hk',
        value: '海口'
      },
      {
        id: 8298,
        key: 'sy',
        value: '三亚'
      },
      {
        id: 8299,
        key: 'wc',
        value: '文昌'
      },
      {
        id: 8297,
        key: 'qh',
        value: '琼海'
      },
      {
        id: 8301,
        key: 'wn',
        value: '万宁'
      },
      {
        id: 9300,
        key: 'wzs',
        value: '五指山'
      },
      {
        id: 8296,
        key: 'df',
        value: '东方'
      },
      {
        id: 8303,
        key: 'zz',
        value: '儋州'
      },
      {
        id: 8491,
        key: 'lg',
        value: '临高'
      },
      {
        id: 8487,
        key: 'cm',
        value: '澄迈'
      },
      {
        id: 8484,
        key: 'da',
        value: '定安'
      },
      {
        id: 8485,
        key: 'tc',
        value: '屯昌'
      },
      {
        id: 8492,
        key: 'cj',
        value: '昌江'
      },
      {
        id: 8493,
        key: 'bs',
        value: '白沙'
      },
      {
        id: 8489,
        key: 'qz',
        value: '琼中'
      },
      {
        id: 8486,
        key: 'ls',
        value: '陵水'
      },
      {
        id: 8488,
        key: 'bt',
        value: '保亭'
      },
      {
        id: 8490,
        key: 'ld',
        value: '乐东'
      }
    ]
  },
  {
    id: 12000,
    key: 'gx',
    value: '广西',
    children: [
      {
        id: 12099,
        key: 'nn',
        value: '南宁'
      },
      {
        id: 12101,
        key: 'lz',
        value: '柳州'
      },
      {
        id: 12095,
        key: 'gl',
        value: '桂林'
      },
      {
        id: 12103,
        key: 'wz',
        value: '梧州'
      },
      {
        id: 12104,
        key: 'bh',
        value: '北海'
      },
      {
        id: 12098,
        key: 'fcg',
        value: '防城港'
      },
      {
        id: 12102,
        key: 'jz',
        value: '钦州'
      },
      {
        id: 12096,
        key: 'gg',
        value: '贵港'
      },
      {
        id: 12105,
        key: 'yl',
        value: '玉林'
      },
      {
        id: 12108,
        key: 'bs',
        value: '百色'
      },
      {
        id: 12107,
        key: 'hz',
        value: '贺州'
      },
      {
        id: 12106,
        key: 'hc',
        value: '河池'
      },
      {
        id: 12100,
        key: 'lb',
        value: '来宾'
      },
      {
        id: 12478,
        key: 'cz',
        value: '崇左'
      }
    ]
  },
  {
    id: 10000,
    key: 'gz',
    value: '贵州',
    children: [
      {
        id: 10118,
        key: 'gy',
        value: '贵阳'
      },
      {
        id: 10120,
        key: 'lps',
        value: '六盘水'
      },
      {
        id: 10126,
        key: 'zy',
        value: '遵义'
      },
      {
        id: 10119,
        key: 'as',
        value: '安顺'
      },
      {
        id: 10125,
        key: 'ty',
        value: '铜仁'
      },
      {
        id: 10124,
        key: 'bj',
        value: '毕节'
      },
      {
        id: 10123,
        key: 'qxn',
        value: '黔西南'
      },
      {
        id: 10122,
        key: 'qdn',
        value: '黔东南'
      },
      {
        id: 10121,
        key: 'qn',
        value: '黔南'
      }
    ]
  },
  {
    id: 28000,
    key: 'sc',
    value: '四川',
    children: [
      {
        id: 28226,
        key: 'cd',
        value: '成都'
      },
      {
        id: 28253,
        key: 'zg',
        value: '自贡'
      },
      {
        id: 28230,
        key: 'fzh',
        value: '攀枝花'
      },
      {
        id: 28234,
        key: 'lz',
        value: '泸州'
      },
      {
        id: 28232,
        key: 'dy',
        value: '德阳'
      },
      {
        id: 28229,
        key: 'my',
        value: '绵阳'
      },
      {
        id: 28225,
        key: 'ggy',
        value: '广元'
      },
      {
        id: 28237,
        key: 'sn',
        value: '遂宁'
      },
      {
        id: 28235,
        key: 'nj',
        value: '内江'
      },
      {
        id: 28233,
        key: 'ls',
        value: '乐山'
      },
      {
        id: 28231,
        key: 'nc',
        value: '南充'
      },
      {
        id: 28254,
        key: 'yn',
        value: '宜宾'
      },
      {
        id: 28224,
        key: 'ga',
        value: '广安'
      },
      {
        id: 28250,
        key: 'dz',
        value: '达州'
      },
      {
        id: 28227,
        key: 'ms',
        value: '眉山'
      },
      {
        id: 28251,
        key: 'ya',
        value: '雅安'
      },
      {
        id: 28247,
        key: 'bz',
        value: '巴中'
      },
      {
        id: 28238,
        key: 'zy',
        value: '资阳'
      },
      {
        id: 28252,
        key: 'an',
        value: '阿坝'
      },
      {
        id: 28236,
        key: 'gz',
        value: '甘孜'
      },
      {
        id: 28228,
        key: 'ls',
        value: '凉山'
      }
    ]
  },
  {
    id: 29000,
    key: 'xz',
    value: '西藏',
    children: [
      {
        id: 29269,
        key: 'ls',
        value: '拉萨'
      },
      {
        id: 29268,
        key: 'nq',
        value: '那曲'
      },
      {
        id: 29480,
        key: 'cz',
        value: '昌都'
      },
      {
        id: 29497,
        key: 'sn',
        value: '山南'
      },
      {
        id: 29271,
        key: 'rzz',
        value: '日喀则'
      },
      {
        id: 29498,
        key: 'al',
        value: '阿里'
      },
      {
        id: 29270,
        key: 'lz',
        value: '林芝'
      }
    ]
  },
  {
    id: 31000,
    key: 'yn',
    value: '云南',
    children: [
      {
        id: 31284,
        key: 'hm',
        value: '昆明'
      },
      {
        id: 31288,
        key: 'qj',
        value: '曲靖'
      },
      {
        id: 31295,
        key: 'yx',
        value: '玉溪'
      },
      {
        id: 31289,
        key: 'bs',
        value: '保山'
      },
      {
        id: 31294,
        key: 'st',
        value: '昭通'
      },
      {
        id: 31290,
        key: 'pe',
        value: '普洱'
      },
      {
        id: 31287,
        key: 'lc',
        value: '临沧'
      },
      {
        id: 31285,
        key: 'lj',
        value: '丽江'
      },
      {
        id: 31291,
        key: 'ws',
        value: '文山'
      },
      {
        id: 31293,
        key: 'hh',
        value: '红河'
      },
      {
        id: 31483,
        key: 'xsbn',
        value: '西双版纳'
      },
      {
        id: 31283,
        key: 'cx',
        value: '楚雄'
      },
      {
        id: 31292,
        key: 'dl',
        value: '大理'
      },
      {
        id: 31286,
        key: 'dh',
        value: '德宏'
      },
      {
        id: 31481,
        key: 'nj',
        value: '怒江'
      },
      {
        id: 31482,
        key: 'dq',
        value: '迪庆'
      }
    ]
  },
  {
    id: 33000,
    key: 'cq',
    value: '重庆'
  },
  {
    id: 11000,
    key: 'gs',
    value: '甘肃',
    children: [
      {
        id: 11258,
        key: 'lz',
        value: '兰州'
      },
      {
        id: 11256,
        key: 'jc',
        value: '金昌'
      },
      {
        id: 11267,
        key: 'by',
        value: '白银'
      },
      {
        id: 11265,
        key: 'ts',
        value: '天水'
      },
      {
        id: 11257,
        key: 'jyg',
        value: '嘉峪关'
      },
      {
        id: 11264,
        key: 'ww',
        value: '武威'
      },
      {
        id: 11266,
        key: 'zy',
        value: '张掖'
      },
      {
        id: 11260,
        key: 'pl',
        value: '平凉'
      },
      {
        id: 11255,
        key: 'jc',
        value: '酒泉'
      },
      {
        id: 11262,
        key: 'qy',
        value: '庆阳'
      },
      {
        id: 11263,
        key: 'dx',
        value: '定西'
      },
      {
        id: 11259,
        key: 'ln',
        value: '陇南'
      },
      {
        id: 11477,
        key: 'gn',
        value: '甘南'
      },
      {
        id: 11261,
        key: 'lx',
        value: '临夏'
      }
    ]
  },
  {
    id: 23000,
    key: 'nx',
    value: '宁夏',
    children: [
      {
        id: 23174,
        key: 'yc',
        value: '银川'
      },
      {
        id: 23171,
        key: 'szs',
        value: '石嘴山'
      },
      {
        id: 23172,
        key: 'wz',
        value: '吴忠'
      },
      {
        id: 23170,
        key: 'gy',
        value: '固原'
      },
      {
        id: 23173,
        key: 'zw',
        value: '中卫'
      }
    ]
  },
  {
    id: 24000,
    key: 'qh',
    value: '青海',
    children: [
      {
        id: 24175,
        key: 'xn',
        value: '西宁'
      },
      {
        id: 24176,
        key: 'hd',
        value: '海东'
      },
      {
        id: 24494,
        key: 'hb',
        value: '海北'
      },
      {
        id: 24479,
        key: 'hn',
        value: '海南'
      },
      {
        id: 24496,
        key: 'gl',
        value: '果洛'
      },
      {
        id: 24178,
        key: 'ys',
        value: '玉树'
      },
      {
        id: 24177,
        key: 'hx',
        value: '海西'
      },
      {
        id: 24495,
        key: 'hn',
        value: '黄南'
      }
    ]
  },
  {
    id: 27000,
    key: 'sx',
    value: '陕西',
    children: [
      {
        id: 27244,
        key: 'xa',
        value: '西安'
      },
      {
        id: 27242,
        key: 'tc',
        value: '铜川'
      },
      {
        id: 27239,
        key: 'bj',
        value: '宝鸡'
      },
      {
        id: 27245,
        key: 'xy',
        value: '咸阳'
      },
      {
        id: 27243,
        key: 'wn',
        value: '渭南'
      },
      {
        id: 27246,
        key: 'ya',
        value: '延安'
      },
      {
        id: 27248,
        key: 'hz',
        value: '汉中'
      },
      {
        id: 27249,
        key: 'yl',
        value: '榆林'
      },
      {
        id: 27240,
        key: 'ak',
        value: '安康'
      },
      {
        id: 27241,
        key: 'sl',
        value: '商洛'
      }
    ]
  },
  {
    id: 30000,
    key: 'xj',
    value: '新疆',
    children: [
      {
        id: 30192,
        key: 'wlmq',
        value: '乌鲁木齐'
      },
      {
        id: 30184,
        key: 'hlmy',
        value: '克拉玛依'
      },
      {
        id: 30187,
        key: 'shz',
        value: '石河子'
      },
      {
        id: 30499,
        key: 'ale',
        value: '阿拉尔'
      },
      {
        id: 30500,
        key: 'tmsh',
        value: '图木舒克'
      },
      {
        id: 30189,
        key: 'wjc',
        value: '五家渠'
      },
      {
        id: 30190,
        key: 'tlf',
        value: '吐鲁番'
      },
      {
        id: 30179,
        key: 'hm',
        value: '哈密'
      },
      {
        id: 30195,
        key: 'ht',
        value: '和田'
      },
      {
        id: 30185,
        key: 'ahs',
        value: '阿克苏'
      },
      {
        id: 30183,
        key: 'hs',
        value: '喀什'
      },
      {
        id: 30186,
        key: 'hzlsz',
        value: '克孜勒苏州'
      },
      {
        id: 30191,
        key: 'bygl',
        value: '巴音郭楞'
      },
      {
        id: 30181,
        key: 'cj',
        value: '昌吉'
      },
      {
        id: 30180,
        key: 'betl',
        value: '博尔塔拉'
      },
      {
        id: 30193,
        key: 'yl',
        value: '伊犁'
      },
      {
        id: 30188,
        key: 'tc',
        value: '塔城'
      },
      {
        id: 30182,
        key: 'alt',
        value: '阿勒泰'
      }
    ]
  },
  {
    id: 34000,
    key: 'xg',
    value: '香港'
  },
  {
    id: 36000,
    key: 'am',
    value: '澳门'
  },
  {
    id: 35000,
    key: 'tw',
    value: '台湾'
  }
]
